export default __webpack_public_path__ + "static/media/slot-cat.b13e42e7.webp";